import Vue from 'vue';
import Vuex from 'vuex';
import common from './common';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userInfo: null,
  },
  modules: {
    common,
  },
  mutations: {
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo;
    }
  }
});

export default store;